import { render, staticRenderFns } from "./ImageDocumentDetails.vue?vue&type=template&id=0e40f222&"
import script from "./ImageDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./ImageDocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e40f222')) {
      api.createRecord('0e40f222', component.options)
    } else {
      api.reload('0e40f222', component.options)
    }
    module.hot.accept("./ImageDocumentDetails.vue?vue&type=template&id=0e40f222&", function () {
      api.rerender('0e40f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imageDocumentDetails/ImageDocumentDetails.vue"
export default component.exports